import * as React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

export default function Copyright(props: any) {
  return (
    <>
      <Typography
        variant="body2"
        align="center"
        {...props}
        sx={[
          ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
          { color: 'text.secondary', mb: 0.5 },
        ]}
      >
        {'Copyright © '}
        <Link color="inherit" href="https://mattruffoni.com/" target="_blank">
          Matt Ruffoni Limited
        </Link>{' '}
        2024-{new Date().getFullYear()}
        {'.'}
      </Typography>
      <Typography
        variant="body2"
        align="center"
        {...props}
        sx={[
          ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
          { color: 'text.secondary', mt: 0 },
        ]}
      >
        <Link color="inherit" component={RouterLink} to="/terms" target="_blank">
          Terms and Conditions
        </Link>{' | '}
        <Link color="inherit" component={RouterLink} to="/privacy" target="_blank">
          Privacy Policy
        </Link>
      </Typography>
    </>
  );
}
